import Rollbar from 'rollbar';

export const SERVER = 'SERVER';
export const CLIENT = 'CLIENT';

const rollbarFactory = (client, token, environment, version) => {
  const isBrowser = typeof window !== 'undefined';
  const isDev = environment === 'development';

  const options = {
    captureUncaught: isBrowser && client === CLIENT,
    captureUnhandledRejections: isBrowser && client === CLIENT,
    hostWhiteList:
      isBrowser && client === CLIENT ? ['www.redbubble.com'] : undefined,
    enabled: !!token
  };

  const rollbar = new Rollbar({
    ...options,
    accessToken: token,
    environment,
    payload: {
      client: {
        javascript: {
          code_version: version,
          source_map_enabled: true,
          guess_uncaught_frames: true
        }
      }
    }
  });

  return (...args) => {
    // eslint-disable-next-line no-console
    if (isDev) console.error('[ROLLBAR]', args[0]);

    rollbar.error(
      ...args.map(arg => {
        if (arg && arg.url && arg.originalUrl) {
          return { ...arg, url: arg.originalUrl };
        }
        return arg;
      })
    );
  };
};

export default rollbarFactory;
